module.exports = __webpack_public_path__ + "img/open3.aa4211e7.png";